import {
  liveVoiceRecord,
  liveVoiceString,
  type LiveVoiceContextKind,
} from './live-voice-protocol';

/** Append has no positive acknowledgment; this is rejection correlation only. */
export class LiveVoiceContextCommands {
  private readonly commands = new Map<string, LiveVoiceContextKind>();

  remember(eventId: string, kind: LiveVoiceContextKind): void {
    this.commands.set(eventId, kind);
    if (this.commands.size > 512) {
      const oldest = this.commands.keys().next().value;
      if (oldest) this.commands.delete(oldest);
    }
  }

  rejectedKind(event: Record<string, unknown>): LiveVoiceContextKind | null {
    if (event.type !== 'error') return null;
    const error = liveVoiceRecord(event.error);
    const id =
      liveVoiceString(error?.client_event_id) ??
      liveVoiceString(event.client_event_id);
    return id ? (this.commands.get(id) ?? null) : null;
  }

  clear(): void {
    this.commands.clear();
  }
}
